const RELATIVE_PATH = /^\/(?!\/|\\)[^\s\\]*$/;

/**
 * A post-login destination taken from user-controllable input. Only a
 * same-origin absolute path is honored: no scheme, no protocol-relative
 * `//host`, no backslash (browsers read `/\host` as `//host`), no
 * whitespace or control characters. Anything else yields `fallback`.
 */
export function safeRedirectPath(
  raw: string | null | undefined,
  fallback = "/",
): string {
  if (typeof raw !== "string") return fallback;
  return RELATIVE_PATH.test(raw) ? raw : fallback;
}
